import { useCallback, useEffect, useRef } from "react";

export const MENU_HOVER_CLOSE_MS = 5000;

export function pointerCanHover() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return true;
  }

  return window.matchMedia("(hover: hover)").matches;
}

export function useHoverTimeoutClose(
  isOpen,
  onClose,
  timeoutMs = MENU_HOVER_CLOSE_MS,
) {
  const hoveredRef = useRef(false);
  const timerRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startTimer = useCallback(() => {
    if (!pointerCanHover()) {
      return;
    }

    clearTimer();
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      if (!hoveredRef.current) {
        onCloseRef.current();
      }
    }, timeoutMs);
  }, [clearTimer, timeoutMs]);

  useEffect(() => {
    if (!isOpen) {
      hoveredRef.current = false;
      clearTimer();
      return undefined;
    }

    startTimer();
    return clearTimer;
  }, [clearTimer, isOpen, startTimer]);

  return {
    onPointerEnter: () => {
      hoveredRef.current = true;
      clearTimer();
    },
    onPointerLeave: () => {
      hoveredRef.current = false;
      if (isOpen) {
        startTimer();
      }
    },
  };
}
